import React, {Component} from 'react'
import './index.scss'
import {Button, message, Modal} from "antd";
import CInput from "./CInput";
import CTable from '@/components/CTable'

class CTables extends Component{
    constructor(props) {
        super(props);
        this.clickHandler = this.clickHandler.bind(this);
        this.modalCancel = this.modalCancel.bind(this)
        this.modalOk = this.modalOk.bind(this)
        this.onChange = this.onChange.bind(this)
        this.deletedata = this.deletedata.bind(this)
    }


    state = {
        visible: false,
        add:{
            id:'',
            name:'',
            unit:'',
            academic:'',
            title:'',
        },
        tHead: [
            {
                key: 'name',
                dataIndex: 'name',
                title: '姓名',
                width:'100px'
            },
            {
                key: 'unit',
                dataIndex: 'unit',
                title: '工作单位',
            },
            {
                key: 'title',
                dataIndex: 'title',
                title: '职务职称',
            },
            {
                key: 'academic',
                dataIndex: 'academic',
                title: '学历',
                width:'300px'
            },
            {
                key: '',
                dataIndex: '',
                title: '操作',
                slot:'operate',
                width:'150px'
            },

        ],
        value:[]
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            value: nextProps.value
        });
    }


    clickHandler(){
        this.setState({
            visible: true
        })
    }

    modalCancel(){
        const data = this.state.add
        for (let key in data) {
            data[key] = ''
        }
        this.setState({
            visible: false,
            add:data
        })
    }

    modalOk(){
        if (this.state.add.name === '') {
            message.error('请输入姓名');
            return false
        }
        const data = this.state.value
        let adddata = true
        data.forEach((item,index)=>{
            if (item.id === this.state.add.id){
                data.splice(index,1,JSON.parse(JSON.stringify(this.state.add)))
                adddata = false
            }
        })
        if (adddata) {
            data.push(JSON.parse(JSON.stringify(this.state.add)))
        }
        const add = this.state.add
        for (let key in add) {
            add[key] = ''
        }
        this.setState({
            value: data,
            visible: false,
            add:add
        });
        this.props.onChange && this.props.onChange(data);
    }

    onChange(name,value){
        this.setState({
            add: {...this.state.add, [name]: value},
        })
    }
    editData(data){
        this.setState({
            add: data,
        },()=>{
            this.setState({
                visible: true
            })
        });
    }

    deletedata(index){
        const data = this.state.value
        data.splice(index,1)
        this.setState({
            value: data,
        });
        this.props.onChange && this.props.onChange(data);
    }

    componentWillMount(){
        let value = this.props.value || '';
        this.setState({
            value: value
        },()=>{
            this.forceUpdate();
        })
    }

    render(){
        return (
            <div>
                {this.state.value.length < 1 && <Button onClick={ this.clickHandler}>
                    增加策展人
                </Button>}
                {
                    this.state.value.forEach(item=>{
                        return<div>{item.id}</div>
                    })
                }
                <CTable ref='tables' checked={false} columns={this.state.tHead} dataSource={this.state.value}>
                    <div
                        slot='operate'
                        render={(text, record, index) => (
                            <div className='operate'>
                                <Button onClick={()=>{this.deletedata(index)}}>
                                    删除
                                </Button>
                                <Button onClick={()=>{this.editData(record)}}>
                                    编辑
                                </Button>
                            </div>
                        )} />
                </CTable>
                <Modal
                    title='增加策展人'
                    visible={this.state.visible}
                    onOk={this.modalOk}
                    onCancel={this.modalCancel}
                    closable={true}
                    width={400}
                >
                    <div>
                        <div>
                            <div style={{margin: '10px 0', fontWeight: 'bold'}}>
                                <span style={{color: 'red'}}>*</span>
                                姓名
                            </div>
                            <CInput type='input' value={this.state.add.name} onChange={(e)=>{this.onChange('name',e)}} />
                        </div>
                        <div>
                            <div style={{margin:'10px 0',fontWeight:'bold'}}>工作单位</div>
                            <CInput type='input' value={this.state.add.unit} onChange={(e)=>{this.onChange('unit',e)}} />
                        </div>
                        <div>
                            <div style={{margin:'10px 0',fontWeight:'bold'}}>职务、职称</div>
                            <CInput type='input' value={this.state.add.title}   onChange={(e)=>{this.onChange('title',e)}} />
                        </div>
                        <div>
                            <div style={{margin:'10px 0',fontWeight:'bold'}}>学历</div>
                            <CInput type='input' value={this.state.add.academic} onChange={(e)=>{this.onChange('academic',e)}} />
                        </div>
                    </div>
                </Modal>
            </div>
        )
    }
}

export default CTables
